import State from '../state'

function findRequired (product, depth = 0) {
  let productIDs = product.required
  if (!productIDs) {
    return []
  }

  if (!Array.isArray(productIDs)) {
    productIDs = productIDs.toString().split(',')
  }

  let result = []

  const categories = State.selection.categories
  for (const category of categories) {
    const searchResult = category.products.filter(
      p => !p.active && // Required check is niet van toepassing als product al active is.
            productIDs.includes(p.product_id.toString())
    )

    result = [...result, ...searchResult]
  }

  const maxDepth = 3
  if (depth < maxDepth) {
    for (const requirement of result) {
      const nestedRequirements = findRequired(requirement, depth + 1)
      result = [...result, ...nestedRequirements]
    }
  }

  const unique = result.filter((req, index, self) => {
    if (req.product_id === product.product_id) {
      return false
    }

    return self.indexOf(req) === index
  })

  return unique
}

function findRequiredActive (product, depth = 0) {
  let productIDs = product.required
  if (!productIDs) {
    return []
  }

  if (!Array.isArray(productIDs)) {
    productIDs = productIDs.toString().split(',')
  }

  let result = []

  const categories = State.selection.categories
  for (const category of categories) {
    const searchResult = category.products.filter(
      p => p.active && // Required check is niet van toepassing als product al active is.
            productIDs.includes(p.product_id.toString())
    )

    result = [...result, ...searchResult]
  }

  const unique = result.filter((req, index, self) => {
    if (req.product_id === product.product_id) {
      return false
    }

    return self.indexOf(req) === index
  })

  return unique
}

function findAllWithSameRequirementsDeactivated (product, category) {
  let productIDs = product.required
  const notCombinedWith = product.not_combined_with
  if (!productIDs) {
    return []
  }
  if (notCombinedWith || notCombinedWith !== '') {
    return []
  }
  if (!Array.isArray(productIDs)) {
    productIDs = productIDs.toString().split(',')
  }
  // in same category
  const productsInCategory = []
  console.log(productIDs)
  category.products.map(pr => {
    console.log(pr.product_id)
    if (
      productIDs.includes(pr.product_id.toString())
    ) {
      productsInCategory.push(pr)
    }
  })
  console.log(productsInCategory)
  if (productsInCategory.length > 0) {
    return []
  }

  let result = []
  if (product.active === 1 || product.active === true) {
    const categories = State.selection.categories
    for (const category of categories) {
      const searchResult = []
      for (const p of category.products) {
        if (p.active === 1 || p.active === true) {
          if (p.required !== null &&
              productIDs.every(v => p.required.toString().split(',').includes(v)) &&
              p.product_id !== product.product_id && p.type !== 'BASIS') {
            searchResult.push(p)
          }
        }
      }

      // searchResult = category.products.filter(
      //   p =>
      //     p.active === 1 &&
      //     p.required &&
      //     productIDs.every(v => p.required.toString().split(',').includes(v))
      // )

      result = [...result, ...searchResult]
    }

    if (result.length === 0) {
      var requiredToDeactivate = findRequiredActive(product)
      // exclude BASIS
      var returnValue = requiredToDeactivate.filter(value => value.type !== 'BASIS')
      return returnValue
    }
  }
  return []
}

function findNotCombinedWith (product) {
  const productID = product.product_id.toString()

  let result = []

  const categories = State.selection.categories
  for (const category of categories) {
    const searchResult = category.products.filter(
      p =>
        p.active &&
        p.not_combined_with &&
        p.type !== 'BASIS' &&
        p.not_combined_with.toString().split(',').includes(productID)
    )

    result = [...result, ...searchResult]
  }

  return result
}

function findNotCombinedWithBASIS (product) {
  const productID = product.product_id.toString()
  let result = []

  const categories = State.selection.categories
  for (const category of categories) {
    const searchResult = category.products.filter(
      p =>
        p.active &&
        p.not_combined_with &&
        p.not_combined_with.toString().split(',').includes(productID)
    )

    result = [...result, ...searchResult]
  }
  return result
}

function checkDisabled (product) {
  let returnValue = false

  if (product.active === 0 || product.active === false) {
    if (findRequired(product).length > 0) {
      returnValue = true
    }

    if (findNotCombinedWith(product).length > 0) {
      returnValue = true
    }

    if (findNotCombinedWithBASIS(product).length > 0) {
      returnValue = true
    }
  }
  // if (returnValue === true) {
  //   product.active = 0
  // }

  return returnValue
}

function checkNotNeeded (product, category) {
  let returnValue = false

  if (product.active === 1 || product.active === true) {
    var rev = findAllWithSameRequirementsDeactivated(product, category) || []
    if (rev.length > 0) {
      returnValue = true
    }
  }

  return returnValue
}

function findAllActiveWhen (product) {
  // return all products must be set active when this product is set active.

  const productID = product.product_id.toString()

  let result = []

  const categories = State.selection.categories
  for (const category of categories) {
    const searchResult = category.products.filter(
      p =>
        p.active_when &&
        p.active_when.toString().split(',').includes(productID)
    )

    result = [...result, ...searchResult]
  }

  return result
}

function findAllEnabledDependants (option) {
  let enabledDependants = []
  let productIDs = [option.product_id.toString()]
  if (!Array.isArray(productIDs)) {
    productIDs = productIDs.toString().split(',')
  }

  const categories = State.selection.categories
  for (const category of categories) {
    const catResult = []
    for (const p of category.products) {
      if (p.active === 1 || p.active === true) {
        if (p.required !== null &&
          productIDs.every(v => p.required.toString().split(',').includes(v)) &&
          p.product_id !== option.product_id && p.type !== 'BASIS') {
          catResult.push(p)
        }
      }
    }

    // searchResult = category.products.filter(
    //   p =>
    //     p.active === 1 &&
    //     p.required &&
    //     productIDs.every(v => p.required.toString().split(',').includes(v))
    // )

    enabledDependants = [...enabledDependants, ...catResult]
  }
  return enabledDependants
}

function checkDependantsEnabled (option) {
  let returnValue = false

  if (option.active === 1 || option.active === true) {
    var rev = findAllEnabledDependants(option) || []
    if (rev.length > 0) {
      returnValue = true
    }
  }

  return returnValue
}

export default {
  findRequired,
  findNotCombinedWith,
  findNotCombinedWithBASIS,
  findAllWithSameRequirementsDeactivated,
  checkDisabled,
  checkNotNeeded,
  findAllActiveWhen,
  checkDependantsEnabled,
  findAllEnabledDependants
}
